export default "__VITE_ASSET__Bfly8$EL__"